.modal {
  max-width: 400px;
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  justify-content: space-between;
}

.textInput {
  margin-top: 12px;
}

.fieldTitle {
  margin: 6px 0;
}

.fieldSubTitle {
  font-size: 12px;
  margin-bottom: 6px;
  font-weight: 400;
}
